import type { CityConfig } from "../city-template/types";

export const bathConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — Sagadahoc County Clerk", href: "https://www.sagadahoccountyme.gov/", description: "Sagadahoc County Clerk — marriage license issuance" },
    { label: "Divorce Records — Sagadahoc County Clerk", href: "https://www.sagadahoccountyme.gov/", description: "Sagadahoc County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Bath",
  state: "Maine",
  stateAbbr: "ME",
  slug: "bath",
  route: "/bath",
  title: "Emergency Passport Bath, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Bath, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Bath, Brunswick, Topsham, Woolwich, and Sagadahoc County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Bath, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Bath and Sagadahoc County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Bath%20Maine%20historic%20shipbuilding%20city%2C%20Victorian%20downtown%20architecture%2C%20classic%20New%20England%20commercial%20buildings%20along%20Front%20Street%2C%20panoramic%20view%20of%20Kennebec%20River%20with%20historic%20iron%20works%2C%20charming%20New%20England%20maritime%20town%20atmosphere%2C%20warm%20afternoon%20light%2C%20professional%20photography%2C%20no%20people%20or%20visible%20text%2C%20scenic%20coastal%20town%20setting%20with%20river%20and%20boats&width=1800&height=700&seq=bath-me-hero-001&orientation=landscape",
  heroImageAlt: "Bath Maine historic Victorian downtown along the Kennebec River with shipbuilding heritage",
  geoPosition: "43.9161;-69.8203",
  geoPlacename: "Bath, Maine",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 150 miles (2.5 hours) from Bath, ME",
  },
  nearbyCitiesZips: [
    { name: "Downtown Bath", zips: "04530" },
    { name: "Brunswick", zips: "04011" },
    { name: "Topsham", zips: "04086" },
    { name: "Woolwich", zips: "04579" },
    { name: "West Bath", zips: "04530" },
    { name: "Phippsburg", zips: "04562" },
    { name: "Bowdoin", zips: "04287" },
    { name: "Bowdoinham", zips: "04008" },
    { name: "Arrowsic", zips: "04530" },
    { name: "Georgetown", zips: "04548" },
    { name: "Freeport", zips: "04032" },
    { name: "Harpswell", zips: "04079" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Bath departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Brunswick", route: "/brunswick" },
    { name: "Emergency passport help in Portland", route: "/portland-me" },
    { name: "Urgent passport services in Freeport", route: "/freeport" },
    { name: "Same-day passport help in Topsham", route: "/topsham" },
    { name: "Expedited passport services in Augusta", route: "/augusta-me" },
    { name: "Passport courier services in Scarborough", route: "/scarborough" },
    { name: "Rush passport help in South Portland", route: "/south-portland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Bath, Maine remotely via secure courier. We do not have a walk-in office in Bath — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Bath travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving Sagadahoc County and the Midcoast region",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Bath and the Sagadahoc County region. From historic Front Street downtown to the riverside neighborhoods along the Kennebec — we help Bath travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Bath neighborhoods and nearby towns including Brunswick, Topsham, Woolwich, West Bath, Phippsburg, Bowdoin, Bowdoinham, Arrowsic, and Georgetown. If you are in the Sagadahoc or midcoast Maine area, we have you covered.",
  howItWorksIntro: "Most Bath travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Bath is a historic shipbuilding town with a strong international travel community. Whether you're cruising out of Portland or flying to Europe, here are the most common mistakes we see from Bath-area travelers.",
  testimonialsIntro: "Bath travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Bath? Here are the most common ones we hear from Sagadahoc County travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Bath international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "James W.",
      location: "Bath, ME",
      rating: 5,
      text: "Our family cruise left in five days and I discovered my passport was expired. Fast Passport Center had my renewal processed in 48 hours. I dropped documents at the Bath Post Office and the rest was handled. Outstanding service.",
      service: "Emergency Passport",
    },
    {
      name: "Margaret T.",
      location: "Topsham, ME",
      rating: 5,
      text: "Needed to renew my passport for a European river cruise. Fast Passport Center caught an issue with my photo before submission. Had my passport in 6 days. The best passport service for midcoast Maine residents.",
      service: "Passport Renewal",
    },
    {
      name: "Alan C.",
      location: "Brunswick, ME",
      rating: 5,
      text: "Lost my passport two weeks before a conference in London. Fast Passport Center handled the DS-64 form and got me a replacement in 3 days. Professional service from start to finish.",
      service: "Lost Passport",
    },
    {
      name: "Rachel F.",
      location: "Woolwich, ME",
      rating: 5,
      text: "First-time passport for my daughter. Fast Passport Center explained the two-parent requirement and helped us find the closest acceptance clerk. Her passport arrived in 5 days, well before our trip.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "bath-1",
      name: "Bath Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "880 Washington St",
      city: "Bath",
      state: "ME",
      zip: "04530",
      phone: "(207) 443-1316",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Bath",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Limited passport acceptance hours. Call ahead to confirm availability and schedule appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "bath-2",
      name: "Brunswick Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "140 Pleasant St",
      city: "Brunswick",
      state: "ME",
      zip: "04011",
      phone: "(207) 725-6441",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles from downtown Bath",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular option for Brunswick, Topsham, and Bowdoin residents. More appointment slots available.",
      icon: "ri-mail-line",
    },
    {
      id: "bath-3",
      name: "Topsham Town Office",
      type: "Town Office Passport Acceptance",
      address: "100 Main St",
      city: "Topsham",
      state: "ME",
      zip: "04086",
      phone: "(207) 725-1728",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "7 miles from downtown Bath",
      website: "https://www.topsham.me.us/",
      websiteLabel: "Topsham Town Office",
      notes: "Good option for Topsham and Bowdoinham residents. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "bath-4",
      name: "Bowdoin Town Office",
      type: "Town Office Passport Acceptance",
      address: "1440 Maine St",
      city: "Bowdoin",
      state: "ME",
      zip: "04287",
      phone: "(207) 666-3051",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "10 miles from Bath",
      website: "https://www.bowdoinmaine.org/",
      websiteLabel: "Bowdoin Town Office",
      notes: "Limited hours. Call ahead to confirm passport acceptance days.",
      icon: "ri-government-line",
    },
    {
      id: "bath-5",
      name: "Woolwich Town Office",
      type: "Town Office Passport Acceptance",
      address: "19 Route 1",
      city: "Woolwich",
      state: "ME",
      zip: "04579",
      phone: "(207) 443-8431",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "12 miles from Bath",
      website: "https://www.woolwich.me/",
      websiteLabel: "Woolwich Town Office",
      notes: "Good option for Woolwich and Phippsburg residents.",
      icon: "ri-government-line",
    },
    {
      id: "bath-6",
      name: "Freeport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9 School St",
      city: "Freeport",
      state: "ME",
      zip: "04032",
      phone: "(207) 865-2013",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles from Bath",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good backup option for Freeport and Harpswell residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Maine photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Bath acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Bath applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Bath families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Bath travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Bath or Brunswick." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bath address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Bath, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Bath in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Bath travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Bath, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Bath residents.",
    },
    {
      q: "Where can I get a fast passport renewal in Bath, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Bath with no office visit required. We serve all Bath neighborhoods and the surrounding Sagadahoc County area. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "How close is Bath to the Boston Passport Agency?",
      a: "Bath is approximately 150 miles from the Boston Passport Agency — about a 2.5-hour drive. With Fast Passport Center, you avoid that trip entirely. We courier your documents directly to State Department facilities.",
    },
    {
      q: "What acceptance facilities are near Bath, Maine?",
      a: "Options near Bath include the Bath Post Office (04530), Brunswick Post Office (04011), and Topsham Town Office (04086). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "What if I live in Brunswick, Topsham, or Woolwich?",
      a: "We serve all of Sagadahoc County and the surrounding midcoast area including Bath, Brunswick, Topsham, Woolwich, Bowdoin, Bowdoinham, and Phippsburg. Our overnight shipping labels work from any UPS location, so your exact address doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Bath?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline and needs.",
    },
    {
      q: "What documents do I need for a first-time passport in Bath?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Bath?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Bath families through the entire process and help schedule acceptance clerk appointments.",
    },
    {
      q: "Is there a UPS Store near Bath for shipping documents?",
      a: "The UPS Store in Brunswick is about 5 miles from Bath. We provide a prepaid overnight label — just drop your package at any UPS location or schedule a pickup. The Bath Post Office can also handle USPS Priority Mail Express.",
    },
    {
      q: "Can I get passport photos taken in Bath?",
      a: "The CVS Pharmacy in Bath offers passport photos. Rite Aid and Walgreens in Brunswick also have photo services. The Walmart in Freeport is about 15 miles away. We recommend reviewing your photos with us before your acceptance clerk visit.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Bath", address: "870 Washington St, Bath, ME 04530", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Rite Aid — Brunswick", address: "132 Pleasant St, Brunswick, ME 04011", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "Walgreens — Brunswick", address: "110 Pleasant St, Brunswick, ME 04011", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Photo Center — Brunswick", address: "15 Cushing St, Brunswick, ME 04011", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walmart.com/" },
    { name: "UPS Store — Brunswick", address: "140 Pleasant St, Brunswick, ME 04011", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Topsham", address: "45 Topsham Fair Mall Rd, Topsham, ME 04086", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Freeport", address: "9 School St, Freeport, ME 04032", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Freeport", address: "11 Bow St, Freeport, ME 04032", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    {
      name: "BMV — Bath",
      address: "45 Front St, Bath, ME 04530",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Limited services. Full BMV transactions may require visiting the Brunswick office.",
      featured: true,
    },
    {
      name: "BMV — Brunswick",
      address: "22 Bath Rd, Brunswick, ME 04011",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. Online appointment booking available. 5 miles from Bath.",
      featured: true,
    },
    {
      name: "BMV — Topsham",
      address: "100 Main St, Topsham, ME 04086",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Basic services. Book appointment online.",
      featured: false,
    },
    {
      name: "BMV — Freeport",
      address: "15 Bow St, Freeport, ME 04032",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "35 miles from Bath (45 minutes)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with direct flights to Canada, Florida, and major U.S. hubs. The closest international departure point for Bath and Sagadahoc County travelers.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: true,
    },
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "100 miles from Bath (1.75 hours)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Maine's second busiest airport. Alternative for northern connections and seasonal international flights.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: false,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "150 miles from Bath (2.5 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many midcoast Maine travelers connect through Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};